import moment from "moment";
import {ActionCreateRequestActivityEnum} from "../../services/openapi";
import noAvatar from "../../assets/img/dummy/noavatar40.png";

export const transformCampaignList = (content = []) => {
  const outList = content?.map((item) => {
    return {
      ...item,
      percent: item?.stats?.completionPercentage,
      startDate: item?.startTime && moment(item?.startTime).format('DD-MM-YYYY'),
      endDate: item?.endTime ? moment(item?.endTime).format('DD-MM-YYYY') : '...',
      totalEvents: item?.stats?.totalActions || 0,
      completedEvents: item?.stats?.completedActions || 0,
      totalProfiles: item?.socialProfileIds?.length || 0,
    };
  });
  console.log('transformCampaignList', outList);

  return outList;
};

export const transformCampaignToForm = (item = {}) => {
  const formData = {
    name: item.name || "",
    description: item.description || "",
    startDate: item?.startTime ? moment(item.startTime) : null,
    endDate: item?.endTime ? moment(item.endTime) : null,
    tags: item.tags || [],
    //avatars: item.avatars || [],
    socialNetwork: item.socialNetwork || "twitter",
  }


  return formData;
}

export const transformCampaignToSave = (formData = {}) => {
  const preparedFormValues = {
    ...formData,
    startTime: formData?.startDate ? moment(formData.startDate).toISOString() : null,
    endTime: formData?.endDate ? moment(formData.endDate).toISOString() : null,
  };
  return preparedFormValues;
}

export const transformCampaign = (apiCampaign = {}) => {
  const outCamapaign = {
    ...apiCampaign,
    profiles: [],
    totalEvents: apiCampaign?.stats?.totalActions || 0,
    completedEvents: apiCampaign?.stats?.completedActions || 0,
    pendingEvents: apiCampaign?.stats?.pendingActions || 0,
    errorEvents: apiCampaign?.stats?.failedActions || 0,
  };
  return outCamapaign;
}

export const transformEventToSave = (formData = {}, type = 'post') => {
  let activity = ActionCreateRequestActivityEnum.UserPost;
  if (type === 'comment') {
    activity = ActionCreateRequestActivityEnum.CommentPost;
  }
  if (type === 'like') {
    activity = ActionCreateRequestActivityEnum.LikePost;
  }
  if (type === 'url') {
    activity = ActionCreateRequestActivityEnum.GetPost;
  }


  const preparedEvent = {
    socialProfileId: formData?.assignedUser,
    activity,
    timestamp: moment(formData?.publicationDate, 'DD-MM-YYYY HH:mm').format('x') * 1,
    text: formData?.text,
  };

  if (type === 'url') {
    preparedEvent.postId = formData?.text;
    delete preparedEvent.text;
  }

  if (formData?.parentActionId) {
    preparedEvent.parentActionId = formData.parentActionId;
  }

  return preparedEvent;
}

export const transformEventsArrayToSave = (formData = {}) => {
  const preparedEvent = {
    socialProfileId: formData?.assignedUser,
    activity: ActionCreateRequestActivityEnum.UserPost,
    timestamp: moment(formData?.publicationDate, 'DD-MM-YYYY HH:mm').format('x') * 1,
    text: formData?.text,
  };
  return [preparedEvent];
}

export const transformCampaignPost = (apiPost = {}) => {
  const outPost = {
    ...apiPost,
    type: 'post',
    //image: noAvatar,
    content: apiPost.text,
    mode: 'manual',
    date: moment(apiPost.timestamp).format('DD-MM-YYYY'),
    time: moment(apiPost.timestamp).format('HH:mm'),
    title: moment(apiPost.timestamp).format('DD-MM-YYYY HH:mm'),
  };
  return outPost;
}

export const transformCampaignPosts = (apiPosts = {}) => {
  const {content = []} = apiPosts;
  const outPosts = content?.map(post => transformCampaignPost(post));
  return outPosts;
}

export const transformCampaignComment = (apiComment = {}) => {
  const outComment = {
    ...apiComment,
    type: 'comment',
    //image: noAvatar,
    content: apiComment.text,
    mode: 'manual',
    date: moment(apiComment.timestamp).format('DD-MM-YYYY'),
    time: moment(apiComment.timestamp).format('HH:mm'),
    title: moment(apiComment.timestamp).format('DD-MM-YYYY HH:mm'),
  };
  return outComment;
}

export const transformCampaignComments = (apiComments = {}) => {
  const {content = []} = apiComments;
  const outComments = content?.map(comment => transformCampaignComment(comment));
  return outComments;
}

export const transformCampaignLike = (apiLike = {}) => {
  const outLike = {
    ...apiLike,
    type: 'like',
    //image: noAvatar,
    mode: 'manual',
    date: moment(apiLike.timestamp).format('DD-MM-YYYY'),
    time: moment(apiLike.timestamp).format('HH:mm'),
    title: moment(apiLike.timestamp).format('DD-MM-YYYY HH:mm'),
  }
  return outLike;
}

export const transformCampaignLikes = (apiLikes = {}) => {
  const {content = []} = apiLikes;
  const outLikes = content?.map(like => transformCampaignLike(like));
  return outLikes;
}

export const transformPostChildren = (apiChildren = []) => {
  const outChildren = apiChildren?.map(event => {
    switch (event.activity) {
      case 'LIKE_POST':
        return transformCampaignLike(event);
        break;
      case 'COMMENT_POST':
        return transformCampaignComment(event);
        break;
      default:
        return event;
    }
  });
  return outChildren;
}

export const transformEventFilters = (filters = {}) => {
  const preparedFilters = {};
  if (filters?.type) {
    preparedFilters.activity = filters.type;
  }
  if (filters?.dateFrom) {
    preparedFilters.startPeriod = moment(filters.dateFrom).format('x');
  }
  if (filters?.dateTo) {
    preparedFilters.endPeriod = moment(filters.dateTo).format('x');
  }

  return preparedFilters;
}



// Helper function to map status codes to visual states
const mapStatusToVisualState = (statusCode, count) => {
  switch (statusCode) {
    case 'ss': // SUCCESS
      return { done: true, progress: 100 };
    case 'sch': // SCHEDULED
      return { done: false, progress: 0 };
    case 'ip': // IN_PROGRESS
      return { done: false, progress: 50 };
    case 'fd': // FAILED
      return { done: false, progress: 0 };
    case 'er': // ERROR
      return { done: false, progress: 0 };
    default:
      return { done: false, progress: 0 };
  }
};

export const transformCampaignWeeks = (apiWeeks = {}) => {
  const {dailyStats = []} = apiWeeks;
  // Process dailyStats into timeline format
  return dailyStats.map(dayStat => {
    const date = moment(dayStat.d, 'YYYY-MM-DD');
    const dayOfWeek = date.day();
    const dayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

    const stats = dayStat.s || {};
    const posts = stats.p || {};
    const likes = stats.l || {};
    const comments = stats.c || {};
    const getPosts = stats?.get_post || {};

    const postsCount = Object.values(posts).reduce((sum, count) => sum + count, 0);
    const likesCount = Object.values(likes).reduce((sum, count) => sum + count, 0);
    const commentsCount = Object.values(comments).reduce((sum, count) => sum + count, 0);
    const getPostsCount = Object.values(getPosts).reduce((sum, count) => sum + count, 0);

    const postsStatusEntries = [...Object.entries(posts), ...Object.entries(getPosts)];
    const [statusCode] = postsStatusEntries[0] || ['sch'];
    const visualState = mapStatusToVisualState(statusCode, postsCount);

    const label = date.format('MMM DD');

    return {
      label,
      posts: postsCount + getPostsCount,
      likes: likesCount,
      comments: commentsCount,
      done: visualState.done,
      progress: visualState.progress,
      dayOfWeek,
      dayName: dayNames[dayOfWeek],
      date: date,
      // Preserve detailed status information
      postsDetails: {...posts, ...getPosts},
      likesDetails: likes,
      commentsDetails: comments
    };
  }).sort((a, b) => moment(a.date).diff(moment(b.date)));
}